export default "__VITE_ASSET__DAiAhdIc__"